import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { CreateErganiSettings } from 'interfaces/ergani';

interface ErganiService {
  getUsername(): Promise<string | null>;
  upsertCredentials(postData: CreateErganiSettings): Promise<AxiosResponse<any>>;
}

const endpoints = {
  getUsername: '/ergani/authenticate/username',
  upsertCredentials: '/ergani/authenticate',
};

export const erganiServices: ErganiService = {
  getUsername: async (): Promise<string | null> => {
    try {
      const response: AxiosResponse<ApiResponseDto<string>> = await apiClient.get(
        endpoints.getUsername
      );

      if (response.data.errors) {
        throw new Error(response.data.errors!.map((error) => error.message).join(', '));
      }

      return response.data.data || null;
    } catch (error: any) {
      // If 404 or no credentials exist, return null
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },
  upsertCredentials: async (postData: CreateErganiSettings): Promise<AxiosResponse<any>> => {
    return apiClient.put(endpoints.upsertCredentials, postData);
  },
};

